<template>
  <v-dialog
    ref="dialog"
    v-model="dialog"
    :return-value.sync="item"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedValue"
        label="Data Autovistoria"
        readonly
        outlined
        dense
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="item"
      scrollable
      range
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="save"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
  export default {
    name: 'SearchOrderInspectionCreatedSelect',

    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      dialog: false,
      item: [],      
    }),

    computed: {
      formattedValue() {
        if (!this.value || this.value.length === 0) return '';
        
        const formatDate = (dateString) => {
          if (!dateString) return '';
          const [year, month, day] = dateString.split('-');
          return `${day}/${month}/${year}`;
        };
        
        const sortedDates = [...this.value].sort();
        if (sortedDates.length === 1) return formatDate(sortedDates[0]);
        
        return `${formatDate(sortedDates[0])} - ${formatDate(sortedDates[1])}`;
      }
    },

    watch: {
      value: {
        immediate: true,
        handler(val) {
          this.item = val && val.length ? [...val] : [];
        }
      },
      dialog(val) {
        if (val) {
          this.item = this.value && this.value.length ? [...this.value] : [];
        }
      }
    },

    methods: {
      save() {
        this.$refs.dialog.save(this.item);
        this.$emit('input', this.item);
      }
    }
  };
</script>
